import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { AlertState, AlertStore } from './alert.store';
import { Observable } from 'rxjs';
import { EntityAlertModel } from './models/entity-alert.model';

@Injectable({ providedIn: 'root' })
export class AlertQuery extends QueryEntity<AlertState> {
  constructor(protected store: AlertStore) {
    super(store);
  }

  /** select all user alerts from store as observable*/
  selectAlerts(): Observable<EntityAlertModel[]> {
    return this.selectAll();
  }

  /** get all user alerts from store */
  getAlerts(): EntityAlertModel[]{
    return this.getAll();
  }
}
